import { useState } from 'react'

export interface ISigninModalsState {
  slackLoginRequired: boolean
  forceChangePassword: boolean
  forceChangePasswordLoading: boolean
}

export interface ISigninModals {
  state: ISigninModalsState
  showSlackLoginRequired: (visible: boolean) => void
  showForceChangePassword: (visible: boolean) => void
  setForceChangePasswordLoading: (loading: boolean) => void
}

/**
 * Every modal on the page in one place, so the sign-in flows can open one without
 * knowing how it is rendered.
 */
export const useSigninModals = (): ISigninModals => {
  const [slackLoginRequired, setSlackLoginRequired] = useState(false)
  const [forceChangePassword, setForceChangePassword] = useState(false)
  const [forceChangePasswordLoading, setForceChangePasswordLoading] = useState(false)

  return {
    state: {
      slackLoginRequired,
      forceChangePassword,
      forceChangePasswordLoading,
    },
    showSlackLoginRequired: setSlackLoginRequired,
    showForceChangePassword: setForceChangePassword,
    setForceChangePasswordLoading,
  }
}
